// packages/shared/src/roleforge/methodology/ops-canvas.ts
// Plan 3b-i: V1 default — 3 engines per the BUILD3R Blueprint. Architecturally
// extensible (vertical-specific engine names allowed); the agent reads these as
// seed values and may rename or add per business shape.

import type { OpsCanvasEngineDefault, VerticalEngineDefaults, Vertical } from './types';

export const OPS_CANVAS_DEFAULT_ENGINES: OpsCanvasEngineDefault[] = [
  {
    id: 'acquisition',
    name: 'Acquisition Engine',
    description: 'How customers find you, evaluate you, and become buyers.',
    color: '#7C3AED',
    suggested_steps: [
      'Awareness',
      'Lead Capture',
      'Qualification',
      'Sales Conversation',
      'Conversion',
    ],
  },
  {
    id: 'delivery',
    name: 'Delivery Engine',
    description: 'How the product or service gets created and delivered.',
    color: '#10A87A',
    suggested_steps: [
      'Onboarding',
      'Production',
      'Quality Check',
      'Hand-off',
      'Wrap-up',
    ],
  },
  {
    id: 'support',
    name: 'Support Engine',
    description: 'How questions, issues, and retention are handled after the sale.',
    color: '#F59E0B',
    suggested_steps: [
      'Inbound Triage',
      'Resolution',
      'Follow-up',
      'Renewal / Retention',
    ],
  },
];

export function getEngineDefault(id: string): OpsCanvasEngineDefault | undefined {
  return OPS_CANVAS_DEFAULT_ENGINES.find((e) => e.id === id);
}

export function getEngineColor(id: string): string {
  return getEngineDefault(id)?.color ?? '#475569'; // graphite fallback
}

// ─── Vertical engine defaults (Plan 3e-i) ───────────────────────────────

export const VERTICAL_ENGINE_DEFAULTS: VerticalEngineDefaults = {
  services: ['Acquisition', 'Delivery', 'Support'],
  b2b_saas: ['Acquisition', 'Onboarding', 'Customer Success'],
  ecommerce: ['Acquisition', 'Fulfillment', 'Retention'],
  local_services: ['Acquisition', 'Service Delivery', 'Repeat & Referral'],
  default: ['Acquisition', 'Delivery', 'Support'],
};

export function getVerticalEngines(vertical: Vertical | null | undefined): string[] {
  switch (vertical) {
    case 'services':
    case 'b2b_saas':
    case 'ecommerce':
    case 'local_services':
      return VERTICAL_ENGINE_DEFAULTS[vertical];
    default:
      return VERTICAL_ENGINE_DEFAULTS.default;
  }
}
